<template>
  <el-dialog
    title="分享"
    :visible.sync="visible"
    width="427px"
    style="z-index: 1000"
    :before-close="close"
    append-to-body
  >
    <div id="_detail_share_container_" v-if="detail">
      <div class="header" v-if="active === 1">
        <img class="logo" src="@/assets/images/share-logo.png" alt="" />
        <!--        <span class="desc">全球精品游戏wiki攻略站</span>-->
      </div>
      <div class="tj-container" :class="[zsTjTheme]">
        <div class="tj-main-bg">
          <div class="wrapper">
            <!-- 白色主题背景 -->
            <div class="light-bg" v-if="isShowLightBg">
              <img class="lh" :src="currentStyle.live2d.lh.value" alt="" />
            </div>
            <!-- 导航栏 -->
            <div class="nav">
              <template v-for="item in navList">
                <div
                  v-if="!item.isHidden"
                  class="nav-item"
                  :key="item.id"
                  :class="[tabActive == item.id ? 'active' : '']"
                  @click="handleTabsChange(item.id)"
                >
                  <SvgIcon class="icon" :iconClass="item.icon" />
                  {{ item.name }}
                </div>
              </template>
            </div>
            <div v-if="tabActive === 0 || tabActive === 1" class="content">
              <div class="left">
                <Character :dataSource="dataSource.base.character" />
                <div class="panel-item" v-if="tabActive == 0" style="margin-top: 54px;">
                  <div class="skin-box">
                    <Skin :current="currentStyle" :dataSource="dataSource.style" @switch="switchStyle" />
                  </div>
                  <Skill :dataSource="currentStyle.skill" />
                </div>
                <!-- <div class="panel-item" v-if="tabActive == 1" style="margin-top: 32px;">
                  <Attr :dataSource="dataSource.base.attr" />
                  <ExclusiveEquipment :dataSource="dataSource.base.exclusiveEquipment" />
                  <TalentSkill :dataSource="dataSource.base.talentSkill" />
                  <SkinEvalution :dataSource="dataSource.style" />
                </div> -->
                <div class="panel-item" v-if="tabActive == 1" style="margin-top: 47px;">
                  <div class="skin-box-1">
                    <Skin :current="currentStyle" :dataSource="dataSource.style" @switch="switchStyle" />
                  </div>
                  <div class="file-tab">
                    <div class="file-tab-header">
                      <div class="item" :class="[fileTabActive == 0 ? 'active' : '']">
                        档案信息
                      </div>
                      <div class="item" :class="[fileTabActive == 1 ? 'active' : '']">
                        角色语音
                      </div>
                    </div>
                    <div class="file-tab-container">
                      <div class="item" v-if="fileTabActive == 0">
                        <Introduction :dataSource="currentStyle.introduction" />
                      </div>
                      <div class="item" v-if="fileTabActive == 1">
                        <Voices :dataSource="currentStyle.voices" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right">
                <div class="live2d-box">
                  <Live2d
                    :showLh="true"
                    :dataSource="currentStyle.live2d"
                    :videoSrc="currentStyle.skill.video.value"
                    :attrValue="dataSource.base.character.attr1.name.value"
                  />
                </div>

                <div class="skin-box">
                  <Skin :current="currentStyle" :dataSource="dataSource.style" @switch="switchStyle" />
                </div>
              </div>
            </div>
            <template v-if="tabActive === 3">
              <ClothContainer
                :isShareView="true"
                :currentStepIndex="currentStepIndex"
                :currentStyle="currentStyle"
                :dataSource="dataSource"
                :tjContentSource="tjContentSource"
                @switchStyle="switchStyle"
              />
            </template>
            <!-- 养成模拟 -->
            <template v-if="tabActive === 2">
              <Cultivation :dataSource="dataSource" :contentId="detail.id" :cultivationData="cultivationData" />
            </template>
          </div>
        </div>
      </div>
      <div
        class="footer"
        :class="[
          active === 0 ? 'footerMaskLayer' : '',
          [2, 3].includes(tabActive) ? 'footer-light-theme' : 'footer-dark-theme'
        ]"
      >
        <div class="left">
          <img class="logo" src="@/assets/images/share-logo.png" alt="" />
          <div class="avatar-info">
            <img class="avatar" :src="user.avatar" alt="" />
            <div class="info">
              <div class="username">
                {{ user.username && user.username.length > 4 ? user.username.slice(0, 4) + "..." : user.username }}
              </div>
              <div class="update">{{ dayjs(detail.updated_at * 1000).format("YYYY/MM/DD") }}更新</div>
              <div class="read">{{ formatCount(detail.view_count) }}阅读量</div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="qrcode-box">
            <div class="qrcode">
              <qrcode-vue :correctLevel="3" :margin="0" :size="134" :value="shareUrl" colorDark="#404040" />
              <img class="logo" src="@/assets/images/favicon.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="tab-box">
        <div class="tab">
          <div class="tab-item" :class="{ active: active === 0 }" @click="handleTabChange(0)">海报</div>
          <div class="tab-item" :class="{ active: active === 1 }" @click="handleTabChange(1)">整页截图</div>
        </div>
      </div>
      <div class="container">
        <div class="share-img" v-if="loaded">
          <img :src="shareImg" alt="" />
        </div>
        <div class="empty" v-else>
          <div class="loading_wrapper">
            <div class="loader"></div>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="bottom">
      <button class="btn" @click="saveImg(shareImg, detail.title)">保存图片</button>
      <button class="btn" @click="linkShare">复制链接分享</button>
    </div>
  </el-dialog>
</template>

<script>
import dayjs from "dayjs";
import html2canvas from "html2canvas";
import imagesloaded from "imagesloaded";
import QrcodeVue from "qrcode.vue";
import Clipboard from "clipboard";
// components
import Character from "./components/character.vue";
// import Attr from "./components/attr.vue";
// import ExclusiveEquipment from "./components/exclusiveEquipment.vue";
// import TalentSkill from "./components/talentSkill.vue";
// import SkinEvalution from "./components/skinEvalution.vue";
import Voices from "./components/voices.vue";
import Skin from "./components/skin.vue";
import Skill from "./components/skill.vue";
import Introduction from "./components/introduction.vue";
import Live2d from "./components/live2d.vue";
import Cultivation from "./cultivation/index.vue";
import ClothContainer from "./components/clothContainer.vue";
// plugins
import { toast } from "@/plugins/util";
import eventBus from "@/plugins/eventBus";
// store
import { mapGetters } from "vuex";

export default {
  components: {
    Introduction,
    Skill,
    Skin,
    Voices,
    // TalentSkill,
    // ExclusiveEquipment,
    // SkinEvalution,
    // Attr,
    Character,
    Live2d,
    Cultivation,
    QrcodeVue,
    ClothContainer
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    dataSource: {
      type: Object,
      default: () => ({})
    },
    currentStyle: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    },
    tabActive: {
      type: Number,
      default: 0
    },
    fileTabActive: {
      type: Number,
      default: 0
    },
    tjContentSource: {
      type: Object,
      default: () => ({})
    },
    currentStepIndex: {
      type: Number,
      default: 0
    },
    cultivationData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(["gameInfo", "zsTjTheme"]),
    hasTjContent() {
      const keys = Object.keys(this.tjContentSource);
      return keys.length > 0;
    },
    navList() {
      return [
        {
          id: 0,
          name: "服装技能",
          icon: "zs-tj-nav-1"
        },
        {
          id: 1,
          name: "服装档案",
          icon: "zs-tj-nav-2"
        },

        {
          id: 3,
          name: "服装评测",
          icon: "zs-tj-nav-3",
          isHidden: !(this.hasTjContent || this.loginUser.is_super)
        },
        {
          id: 2,
          name: "顶级面板",
          icon: "zs-tj-nav-4"
        }
      ];
    },
    isShowLightBg() {
      return [2, 3].includes(this.tabActive) && this.currentStepIndex != 1;
    }
  },
  data() {
    return {
      visible: false,
      loaded: false,
      shareImg: "",
      shareUrl: "",
      active: 0,
      isInit: true,
      waterMarkText: ""
    };
  },
  created() {
    this.waterMarkText = this.gameInfo.name + "-Kwiki";
  },
  mounted() {
    eventBus.$on("openZSTJShare", this.open);
  },
  methods: {
    dayjs,
    handleTabChange(active) {
      this.active = active;
      this.loaded = false;
      this.$nextTick(() => {
        this.toImg();
      });
    },
    switchStyle(key) {
      this.currentStyle = { key, ...this.dataSource.style[key] };
      this.$nextTick(() => {
        if (this.refreshMap) this.refreshMap();
      });
    },
    open() {
      this.visible = true;
      this.loaded = false;
      this.shareUrl = window.location.href;
      this.$nextTick(() => {
        const container = document.getElementById("_detail_share_container_");
        // 处理渐变字体
        const textName = container.querySelector(".character .top .name");
        if (textName) {
          textName.style.backgroundClip = "none";
          textName.style.background = "none";
          textName.style.color = "#345487";
        }

        const textNamePy = container.querySelector(".character .py-bg");
        if (textNamePy) {
          textNamePy.style.backgroundClip = "none";
          textNamePy.style.background = "none";
          textNamePy.style.color = "#86a5f1";
        }

        // 图片加载
        const imgs = container.querySelectorAll("img");
        imgs.forEach(img => {
          img.classList.remove("lazy-img");
          const dataSrc = img.getAttribute("data-src") || img.getAttribute("data-real");
          if (dataSrc) {
            img.src = dataSrc;
          }
          img.setAttribute("loading", "eager");
          img.setAttribute("lazy", "loaded");
          img.setAttribute("crossOrigin", "anonymous");
          console.log(img.outerHTML);
        });
        // 视频替换为封面
        const videos = container.querySelectorAll("video");
        videos.forEach(video => {
          const posterHtml = `
          <div style="position: relative;width: 100%;min-height:200px">
            <img src="${video.poster}" alt="" style="width: 100%;" />
            <i class="wiki-icon wiki-icon-video-play" style="display: inline-block;width: 57px;height: 57px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);"></i>
          </div>
          `;
          video.parentNode.innerHTML = posterHtml;
        });
        // iframe
        const iframes = container.querySelectorAll("iframe");
        iframes.forEach(iframe => {
          const tempHtml = `
          <div style="position: relative;width: 100%;min-height:200px;display:flex;align-items: center;justify-content: center; background: #f5f5f5;">
            <span>嵌入内容</span>
          </div>
          `;
          iframe.parentNode.innerHTML = tempHtml;
        });
        this.toImg();
      });
    },
    close() {
      this.visible = false;
      this.active = 0;
    },
    toImg() {
      const container = document.getElementById("_detail_share_container_");
      const _this = this;

      imagesloaded("#_detail_share_container_", function() {
        html2canvas(container, {
          useCORS: true,
          scale: 1,
          scrollX: 0,
          scrollY: 0,
          ignoreElements: el => _this.active === 0 && el.classList.contains("base")
        }).then(canvas => {
          // 创建临时canvas绘制水印
          const tempCanvas = document.createElement("canvas");
          const ctx = tempCanvas.getContext("2d");

          // 设置临时canvas尺寸
          tempCanvas.width = canvas.width;
          tempCanvas.height = canvas.height;

          // 绘制原始内容
          ctx.drawImage(canvas, 0, 0);
          // 绘制水印
          ctx.font = "14px Arial";
          ctx.fillStyle = "rgba(242, 243, 244, 0.05)";
          ctx.textAlign = "center";

          // 创建水印路径
          const angle = -15; // 统一倾斜角度
          ctx.translate(tempCanvas.width / 2, tempCanvas.height / 2);
          ctx.rotate((angle * Math.PI) / 180);

          // 平铺水印
          for (let x = -tempCanvas.width; x < tempCanvas.width * 2; x += 200) {
            for (let y = -tempCanvas.height; y < tempCanvas.height * 2; y += 100) {
              ctx.fillText(_this.waterMarkText, x, y);
            }
          }

          const dataUrl = tempCanvas.toDataURL("image/png");
          _this.loaded = true;
          _this.shareImg = dataUrl;
          if (_this.isInit) {
            _this.isInit = false;
          }
        });
      });
    },
    saveImg(url, name = "gamekee-share-img") {
      // 创建一个隐藏的<a>元素
      const link = document.createElement("a");
      link.style.display = "none";
      // 设置链接的href属性为图片数据
      link.href = url;
      // 设置下载的文件名
      link.download = name + ".png";

      // 添加到DOM中
      document.body.appendChild(link);
      // 触发点击事件
      link.click();
      // 下载完成后移除该元素
      document.body.removeChild(link);
    },
    linkShare() {
      let shareText = `${this.detail.user.username}分享了文章:${this.detail.title}\r\n`;
      shareText += window.location.href + "\r\n";
      shareText += "来自GameKee";
      let $div = document.createElement("div");
      $div.setAttribute("data-clipboard-text", shareText);
      $div.classList.add("page-share-copy-btn");
      document.body.appendChild($div);
      let clipboard = new Clipboard(".page-share-copy-btn");
      clipboard.on("success", e => {
        toast("复制成功！");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        toast("浏览器不支持自动复制,请更换其他浏览器");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      $div.click();
    },
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000;
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿";
        } else {
          return (count / 100000000).toFixed(1) + "亿+";
        }
      } else if (count >= 10000) {
        const num = count / 10000;
        if (num == (count / 10000).toFixed(1)) {
          return num + "W";
        } else {
          return (count / 10000).toFixed(1) + "W+";
        }
      } else if (count >= 1000) {
        const num = count / 1000;
        if (num == (count / 1000).toFixed(1)) {
          return num + "K";
        } else {
          return (count / 1000).toFixed(1) + "K+";
        }
      } else {
        return count;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  border-radius: 12px;
}

/deep/ .el-dialog__header {
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  background: #f1f5fd;
  border-radius: 12px 12px 0 0;
}

/deep/ .el-dialog__body {
  padding: 0;
  background: #f1f5fd;
}

/deep/ .el-dialog__footer {
  padding: 0;
  background: #f1f5fd;
  border-radius: 0 0 12px 12px;

  .bottom {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;

    .btn {
      width: 189px;
      height: 40px;
      background: #dbe2f0;
      border-radius: 20px;
      border: none;
    }
  }
}

.content {
  .tab-box {
    background: #f1f5fd;
    width: 100%;
    padding: 10px 16px;

    .tab {
      width: 388px;
      height: 42px;
      background: #dde5f4;
      border-radius: 21px;
      display: flex;
      align-items: center;
      padding: 0 4px;
      gap: 4px;

      .tab-item {
        width: 190px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: #72818b;
        cursor: pointer;
        border-radius: 17px;

        &.active {
          background: #fff;
          border-radius: 17px;
          font-weight: 600;
          font-size: 14px;
          color: #51616f;
        }
      }
    }
  }

  .container {
    width: 100%;
    height: 395px;
    background: #f1f5fd;
    padding: 10px 16px;
    overflow-y: auto;
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.15);
    // border: none;
    // border-radius: 20px;
    /* 滚动槽 */

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 3px;
      background: rgba(0, 0, 0, 0.06);
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.08);
    }

    /* 滚动条滑块 */

    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: rgba(0, 0, 0, 0.12);
      -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    }

    .share-img {
      width: 100%;
      height: auto;
      box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.15);
      border-radius: 16px;
      font-size: 0;

      img {
        width: 100%;
        border-radius: 16px;
      }
    }
  }

  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 18px;
    height: 395px;
    overflow: hidden;
    border-radius: 34px;
    background: #fff;

    .icon {
      width: 97px;
      height: 97px;
    }

    .desc {
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
    }

    .loading_wrapper {
      width: 96px; /* loader宽度的2倍 */
      height: 96px; /* loader高度的2倍 */
      background: rgba(0, 0, 0, 0.5); /* 黑色半透明 */
      border-radius: 16px; /* 圆角效果 */
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .loader {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: inline-block;
      position: relative;
      border: 3px solid;
      border-color: transparent #0babfd #0babfd;
      animation: rotation 2s linear infinite;
      margin: 20px;
    }

    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}

#_detail_share_container_ {
  background-color: #fff;
  width: 1920px;
  position: fixed;
  left: -20000px;
  // left: 0;
  top: 0;
  z-index: 1000;
  padding-bottom: 185px;
  //border-bottom: 1px solid #f1f5fb;

  .header {
    width: 100%;
    height: 110px;
    background: #151929;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 34px 40px;

    .logo {
      width: 300px;
      height: 45px;
      margin-right: 36px;
      vertical-align: bottom;
    }

    .desc {
      font-weight: 500;
      font-size: 32px;
      color: #757575;
      line-height: 45px;
    }
  }

  .main {
    padding: 20px;
    border-radius: 30px;
  }

  .footerMaskLayer::before {
    position: absolute;
    top: -190px;
    left: 0;
    content: "";
    display: block;
    width: 100%;
    height: 200px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #151929 100%);
  }

  .footer {
    position: absolute;
    bottom: 0px;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 187px;
    padding: 18px 27px 18px;
    color: #c2c2c2;
    display: flex;
    justify-content: space-between;

    .left {
      display: flex;
      gap: 18px;
      width: 80%;
      flex-direction: column;

      .logo {
        width: 300px;
        height: 45px;
        margin: 10px 36px 10px 0;
        vertical-align: bottom;
      }

      .avatar-info {
        display: flex;
        align-items: center;
        width: 100%;

        .avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin-right: 15px;
        }

        .info {
          display: flex;
          width: 80%;

          .username,
          .update,
          .read {
            font-weight: 400;
            font-size: 22px;
            color: #888888;
            line-height: 41px;
            margin-right: 15px;
          }
        }
      }
    }

    .right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 18px;

      .info {
        width: 300px;
        display: flex;
        flex-direction: column;

        .arrow {
          text-align: right;
          margin-bottom: 23px;

          img {
            width: 62px;
            height: 36px;
          }
        }

        .tips {
          width: 100%;
          text-align: right;
          font-weight: 400;
          font-size: 25px;
          color: #999999;
          line-height: 36px;
          margin-bottom: 3px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .qrcode-box {
        width: 146px;
        height: 146px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ffffff;
        //border: 1px solid #404040;
      }

      .qrcode {
        position: relative;
        width: 146px;
        height: 146px;
        padding: 4px;

        .logo {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 32px;
          height: 32px;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
  .footer-light-theme {
    background-color: #fff;
    &::before {
      display: none;
    }
  }
  .footer-dark-theme {
    background-color: #151929;
  }
}

.tj-container {
  width: 100%;
  min-width: 1728px;
  height: 911px;
  background: #19181f;
  background: url("~@/assets/zs_imgs/page-bg.png");
  background-size: cover;
  .tj-main-bg {
    width: 100%;
    height: 100%;
    background: url("~@/assets/zs_imgs/live2d-mask-bg.png") no-repeat;
    // background-size: cover;
  }
  .lz-canvas {
    position: fixed;
    z-index: 0;
    width: 100vw;
    height: 100vh;
  }

  .wrapper {
    position: relative;
    display: flex;
    width: 1728px;
    height: 100%;
    margin: 0 auto;
    .light-bg {
      display: none;
    }
    .nav {
      padding-top: 116px;
      flex-shrink: 0;
      width: 172px;
      height: 100%;
      margin-left: -35px;
      // background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.05) 100%);
      border-right: 1px solid rgba(255, 255, 255, 0.13);
      .nav-item {
        position: relative;
        display: flex;
        align-items: center;
        // justify-content: flex-end;
        width: 100%;
        height: 49px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #3e4551;
        cursor: pointer;
        padding: 0 20px 0 35px;
        margin: 0 auto 28px;
        &::before {
          content: "";
          display: block;
          width: 28px;
          height: 28px;
          margin-right: 17px;
        }
      }
    }
    .content {
      flex-shrink: 0;
      display: flex;
      .left {
        position: relative;
        z-index: 2;
        box-sizing: content-box;
        padding: 0 64px;
        width: 678px;
        .file-tab {
          .file-tab-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 666px;
            height: 46px;
            background: rgba(144, 217, 235, 0.04);
            border-radius: 4px;
            padding: 5px 5px 4px;
            .item {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 327px;
              height: 37px;
              border-radius: 4px;
              font-weight: 400;
              font-size: 16px;
              color: #959595;
              line-height: 22px;
              cursor: pointer;
              &.active {
                font-weight: bold;
                color: #392e25;
                background: #e1dad5;
              }
            }
          }
          .file-tab-container {
            width: 100%;
          }
        }
        .skin-box-1 {
          position: relative;
          padding-bottom: 36px;
        }
        .skin-box {
          position: relative;
          padding-bottom: 20px;
          margin-bottom: 26px;
          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 678px;
            height: 1px;
            background: rgba(111, 160, 210, 0.14);
            border-radius: 1px;
          }
        }
      }
      .right {
        position: relative;
        width: 2560px;
        height: 100%;
        max-height: 1080px;
        min-height: 896px;
        // background: #5989dc;
        margin-left: -980px;
        .live2d-box {
          width: 100%;
          height: 100%;
          img {
            height: 100%;
            width: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }
}

.tj-container.light {
  background: #fff;
  .tj-main-bg {
    background: url("~@/assets/zs_imgs/tj-main-bg.png") no-repeat;
    background-size: cover;
  }

  .wrapper {
    .light-bg {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .lh {
        position: absolute;
        top: 0;
        right: 0;
        max-width: 70%;
        height: 160%;
        margin-top: -8%;
        object-fit: contain;
        object-position: right top;
        filter: hue-rotate(0deg) saturate(0.8) brightness(106%) contrast(99%);
        opacity: 0.28;
      }
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        height: 100%;
        background: url("~@/assets/zs_imgs/tj-light-bg-mask.png") no-repeat;
        background-size: contain;
        background-position: 45px;
      }
    }
    .nav {
      border-right: 1px solid rgba(0, 0, 0, 0.3);

      .nav-item {
        color: #666666;
        &.active {
          color: #333333;
          background: linear-gradient(90deg, rgba(46, 122, 153, 0) 0%, rgba(46, 122, 153, 0.2) 100%);
          &::after {
            display: none;
          }
        }
      }
    }
  }
}
</style>
